export enum Pronoun {
  'Unknown' = 'Prefer not to say',
  'HeHim' = 'He/Him',
  'SheHer' = 'She/Her',
  'TheyThem' = 'They/Them',
  'XiXey' = 'Xi/Xey',
  'ZeZim' = 'Ze/Zim',
}

export const PRONOUN_OPTIONS = [
  {value: Pronoun.Unknown, label: Pronoun.Unknown},
  {value: Pronoun.HeHim, label: Pronoun.HeHim},
  {value: Pronoun.SheHer, label: Pronoun.SheHer},
  {value: Pronoun.TheyThem, label: Pronoun.TheyThem},
  {value: Pronoun.XiXey, label: Pronoun.XiXey},
  {value: Pronoun.ZeZim, label: Pronoun.ZeZim},
];
